import { makeAppKey } from '@atlassian/mpac-api-client';
import { makeInstalledAppFromSPIInstalledApp } from '@atlassian/mpac-spi';
import { makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData } from '../../../records/InstallableApp';
import { makeInstallableAppByKeyIdentifier, toSPIInstallableAddonIdentifier } from '../../../records/InstallableAppIdentifier';
import { makeInstallableAppByManualUrlInstallMode } from '../../../records/InstallMode/InstallableAppByManualUrlInstallMode';
import getSPI from '../../../services/SPI';
import { reflect } from '../../../utils/promise-utils';
import { getRequestId } from '../../../utils/request-utils';
import { retrieveAppDataByUrl } from '../AppDataRetrieval';
import { doSetInstallMode } from '../Installation';
import { parseInstalledAddonResult } from './DeterminingInstallMode';
export const START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL = 'INSTALLATION_START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL';
export const FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL = 'INSTALLATION_FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL';
export const FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR = 'INSTALLATION_FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR';
export const CLEAR_INSTALLABLE_APP_BY_MANUAL_URL = 'INSTALLATION_CLEAR_INSTALLABLE_APP_BY_MANUAL_URL';
export const doStartInstallableAppByManualUrlInstallMode = () => dispatch => {
  dispatch(doSetInstallMode({
    installMode: makeInstallableAppByManualUrlInstallMode()
  }));
};
const startFetchInstallableAppByManualUrl = _ref => {
  let {
    installableAppByUrlId,
    retrievalId
  } = _ref;
  return {
    type: START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL,
    installableAppByUrlId,
    retrievalId
  };
};
const finishFetchInstallableAppByManualUrl = _ref2 => {
  let {
    installableApp,
    installedApp,
    retrievalId
  } = _ref2;
  return {
    type: FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL,
    installableApp,
    installedApp,
    retrievalId
  };
};
const fetchInstallableAppByManualUrlError = _ref3 => {
  let {
    error,
    installableAppByUrlId,
    retrievalId
  } = _ref3;
  return {
    type: FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR,
    error,
    installableAppByUrlId,
    retrievalId
  };
};
export const clearInstallableAppByManualUrl = () => ({
  type: CLEAR_INSTALLABLE_APP_BY_MANUAL_URL
});
export const doFetchInstallableAppByManualUrl = _ref4 => {
  let {
    context,
    installableAppByUrlId,
    mpacBaseUrl
  } = _ref4;
  return dispatch => {
    const retrievalId = getRequestId();
    dispatch(startFetchInstallableAppByManualUrl({
      retrievalId,
      installableAppByUrlId
    }));
    retrieveAppDataByUrl({
      installableAppByUrlId,
      mpacBaseUrl
    }).then(_ref5 => {
      let {
        installableAddon,
        marketplaceApp
      } = _ref5;
      installableAddon.swap().map(error => {
        console.error("The SPI's getInstallableAddon returned an error or invalid shape", error);
        return error;
      }).swap().map(installableAddonRes => makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData(installableAddonRes, marketplaceApp, mpacBaseUrl)).fold(error => {
        dispatch(fetchInstallableAppByManualUrlError({
          error,
          installableAppByUrlId,
          retrievalId
        }));
      }, installableApp => {
        reflect(getSPI().getInstalledAddon({
          contextId: context.id,
          addon: toSPIInstallableAddonIdentifier(makeInstallableAppByKeyIdentifier({
            key: makeAppKey(installableApp.details.key)
          }))
        }).then(installedAddonResult => parseInstalledAddonResult(installedAddonResult))).then(installedAddon => {
          dispatch(finishFetchInstallableAppByManualUrl({
            installableApp,
            installedApp: installedAddon.toOption().map(makeInstalledAppFromSPIInstalledApp),
            retrievalId
          }));
        }).catch(console.error.bind(console));
      });
    }).catch(console.error.bind(console));
  };
};